export default "__VITE_ASSET__LPr3by8f__"